export default __webpack_public_path__ + "static/media/icon8.63837fe3.svg";